export const DOCUMENT_TYPE_KEYS = ['beacon-gsm-concept', 'beacon-survey', 'mobile-survey'];
export const GENERATOR_KINDS = ['beaconPositions', 'measurementPoints', 'summary'];
/** Limits of one document (design 2026-10-31). */
export const DOCUMENT_LIMITS = {
    maxTitleLength: 200,
    /** Serialized blocks of one section, UTF-8 bytes; above that the API answers 413. */
    maxSectionBlocksBytes: 200 * 1024,
    /** Chapter levels - numbering down to `6.2.2.1`. */
    maxSectionDepth: 4,
    maxSectionsPerDocument: 300,
    maxSeriesPerDocument: 20,
    maxCaptionLength: 300,
    maxAlternativeTextLength: 300,
};
// --- document -------------------------------------------------------------
export const DOCUMENT_STATUSES = ['draft', 'published', 'archived'];
// --- document version -----------------------------------------------------
/**
 * Version lifecycle.
 *
 * [VORSCHLAG] The reference documentation contains no approval information, so
 * these states are our proposal and must be confirmed with OSCOM
 * ([OFFEN] R8 in docs/open-decisions.md).
 */
export const DOCUMENT_VERSION_STATUSES = [
    'draft',
    'inReview',
    'approved',
    'published',
    'archived',
];
// --- helpers ---------------------------------------------------------------
/**
 * Builds the visible chapter number from the 1-based positions of a section and
 * its ancestors, e.g. `[6, 2, 2, 1]` -> `6.2.2.1`.
 *
 * Numbers are ALWAYS derived. Storing them is what makes a reordered chapter
 * silently wrong in a hand written document.
 */
export function sectionNumber(positions) {
    return positions.filter((position) => position > 0).join('.');
}
/** Depth of a section, derived from its path. Root sections have level 1. */
export function sectionLevel(section) {
    return Math.max(1, section.path.length);
}
/** A published version must never be modified - single place to ask. */
export function isVersionEditable(version) {
    return version.status === 'draft' || version.status === 'inReview';
}
/** Only published versions may be exported for or shared with a customer. */
export function isVersionShareable(version) {
    return version.status === 'published';
}
//# sourceMappingURL=document.js.map